import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-competencegroups',
    template: require('../shared/list-view.html')
})
export class CompetenceGroups extends ListBase<Nema.Crew.Model.CompetenceGroup>  {
    constructor(
        @Inject("competencegroups") competencegroups: Nema.Crew.Model.CompetenceGroup[],
        crewPermissionsService: CrewPermissionsService) {

        super(competencegroups, crewPermissionsService);
    }

    public newEntityState = "app.settings.competencegroups.new";

    public editEntityState = "app.settings.competencegroups.detail";

    public entityName = "Competence Group";

    public entityNames = "Competence Groups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencegroups/competencegroups.component.ts